import React, { useState } from "react";
import AIAutomationChat from "../components/AIAutomationChat";

const AIAutomationOptionB = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <div className="font-sans text-gray-900 bg-black min-h-screen relative overflow-hidden">
            {/* Modal Video Player */}
            {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 animate-fade-in">
                    <div className="relative w-full max-w-5xl aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl border border-gray-800">
                        <button
                            onClick={closeModal}
                            className="absolute top-4 right-4 z-60 text-white/70 hover:text-white bg-black/50 hover:bg-black/80 rounded-full p-2 transition-all"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <video
                            src="/DocLift-V2.2.mp4"
                            controls
                            autoPlay
                            className="w-full h-full object-contain"
                        />
                    </div>
                </div>
            )}

            {/* Hero Section */}
            <section className="relative min-h-screen flex items-center justify-center px-6 md:px-12 py-20 overflow-hidden bg-gradient-to-b from-[#0f172a] to-[#000000]">

                {/* Decorative Background Elements */}
                <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-purple-900/10 blur-[120px] rounded-full"></div>
                <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-blue-900/10 blur-[120px] rounded-full"></div>


                <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10">
                    {/* Left Column: Text Content */}
                    <div className="text-left animate-fade-in-left">
                        <div className="inline-block px-4 py-1 mb-6 rounded-full bg-blue-900/30 border border-blue-500/30 text-blue-400 text-sm font-semibold tracking-wide uppercase">
                            New Feature Release v2.0
                        </div>
                        <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight mb-6 leading-tight">
                            Smart Automation <br />
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">
                                Made Simple.
                            </span>
                        </h1>
                        <p className="text-xl text-gray-300 mb-8 max-w-lg leading-relaxed">
                            DocLift empowers service businesses to automate communication, capture leads, and scale operations — without the technical headache.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-blue-500/25 transition-all transform hover:-translate-y-1">
                                Get Started Free
                            </button>
                            <button className="flex items-center justify-center px-8 py-4 rounded-xl border border-gray-700 hover:bg-gray-800 text-gray-300 hover:text-white transition-all font-medium">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0h9m3.121-1.612a2.625 2.625 0 0 0-3.42-3.42" />
                                </svg>
                                Book a Demo
                            </button>
                        </div>

                        <div className="mt-8 flex items-center gap-4 text-sm text-gray-500">
                            <div className="flex -space-x-2">
                                <div className="w-8 h-8 rounded-full bg-gray-700 border-2 border-black"></div>
                                <div className="w-8 h-8 rounded-full bg-gray-600 border-2 border-black"></div>
                                <div className="w-8 h-8 rounded-full bg-gray-500 border-2 border-black"></div>
                            </div>
                            <span>Trusted by 500+ businesses</span>
                        </div>
                    </div>

                    {/* Right Column: Video Card */}
                    <div className="relative group animate-fade-in-right">
                        {/* Glow Effect */}
                        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>

                        {/* Video Thumbnail Container */}
                        <div
                            onClick={openModal}
                            className="relative rounded-2xl overflow-hidden bg-gray-900 border border-gray-800 shadow-2xl cursor-pointer group-hover:scale-[1.01] transition-transform duration-300 aspect-video"
                        >
                            {/* Placeholder Thumbnail - In prod use an actual image poster */}
                            <div className="absolute inset-0 bg-gradient-to-tr from-gray-900 via-gray-800 to-gray-900"></div>
                            <img
                                src="/DocLift-girl.png" // Using existing asset as placeholder thumbnail if appropriate, or fallback to simple gradient
                                alt="Video Thumbnail"
                                className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-300"
                                onError={(e) => e.target.style.display = 'none'} // Fallback if image fails
                            />

                            {/* Play Button Overlay */}
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-20 h-20 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center border border-white/20 shadow-lg group-hover:scale-110 transition-transform duration-300 group-hover:bg-white/20">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-white ml-1">
                                        <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                    </svg>
                                </div>
                            </div>

                            {/* Caption */}
                            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
                                <p className="text-white font-medium text-lg">See how DocLift works</p>
                                <p className="text-gray-400 text-sm">2 min walkthrough</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Section (Reused content for context) */}
            <section className="py-20 px-6 bg-[#0f172a] text-white">
                <div className="max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            { title: "Smart Chatbots", icon: "💬", desc: "Automate responses instantly." },
                            { title: "Voice Agents", icon: "🎙️", desc: "Handle calls 24/7 without staff." },
                            { title: "Lead Gen", icon: "🚀", desc: "Capture more customers automatically." }
                        ].map((item, idx) => (
                            <div key={idx} className="bg-white/5 border border-white/10 p-6 rounded-xl hover:bg-white/10 transition-colors">
                                <div className="text-3xl mb-3">{item.icon}</div>
                                <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                                <p className="text-gray-400 text-sm">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Chat Component */}
            <AIAutomationChat />
        </div>
    );
};

export default AIAutomationOptionB;
